import {
    IAnyType,
    OptionalDefaultValueOrFunction,
    types,
    ValidOptionalValues,
} from "mobx-state-tree";

function optional<
    IT extends IAnyType,
    OptionalVals extends ValidOptionalValues
>(type: IT, defaultValueOrFunction: OptionalDefaultValueOrFunction<IT>) {
    return types.optional(
        types.union(type, types.null, types.undefined),
        defaultValueOrFunction,
        [null, undefined],
    );
}
export default { optional };
